import { render, staticRenderFns } from "./APIChannelField.vue?vue&type=template&id=42eee070"
import script from "./APIChannelField.vue?vue&type=script&lang=js"
export * from "./APIChannelField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports